export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8306.eed5b18f.jpg";